/*=========================================================================================
  File Name: moduleEcommerceGetters.js
  Description: Ecommerce Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  isInCart: state => itemId => {
    return state.cartItems.some((item) => item.BARKOD === itemId)
  },
  isInWishList: state => itemId => {
    return state.wishList.some((item) => item.BARKOD === itemId)
  },
  getCartItem: state => itemId => {
    const result = state.cartItems.filter((item) => item.BARKOD === itemId)
    return result.length ? result.pop() : []
  }
}
